import React from 'react';
import { FaEnvelope } from 'react-icons/fa';

const SupportInfo = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <img src="/logo-icon.png" alt="Donor Dispatch" className="h-12 mx-auto mb-4" />
        </div>
        <div className="card p-6 sm:p-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-navy-800 mb-4">Support Information</h1>

          <p className="text-gray-600 mb-8 leading-relaxed text-sm">
            Welcome to DonorDispatch Support! Our dedicated support team is here to assist you with any questions or issues you may encounter while using our platform. Whether you need help scheduling a donation pickup, have questions about how the donation process works, or need assistance with your account, we're just an email away. We strive to provide timely and helpful responses to ensure your donation experience is smooth and rewarding. Our support team is available during regular business hours and typically responds within 24-48 hours.
          </p>

          <div className="space-y-4">
            <div className="flex items-start gap-4 p-5 bg-gray-50 rounded-xl border border-gray-100">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-navy-100 flex-shrink-0">
                <FaEnvelope className="text-lg text-navy-600" />
              </div>
              <div>
                <h2 className="text-base font-semibold text-gray-800">Email Support</h2>
                <a
                  href="mailto:info@donordispatch.com"
                  className="text-brand-navy hover:underline text-sm font-medium"
                >
                  info@donordispatch.com
                </a>
                <p className="text-xs text-gray-400 mt-1">Response time: 24-48 hours</p>
              </div>
            </div>

            <div className="mt-8 p-4 bg-navy-50 rounded-xl border border-navy-100">
              <p className="text-gray-600 text-center text-sm">
                For privacy-related inquiries, please visit our{' '}
                <a href="/privacy-policy" className="text-brand-navy font-medium hover:underline">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportInfo;
